import { FormGroup } from "@angular/forms";
import { DataGridComponent } from './data-grid.component';

export abstract class InlineEditGridComponent extends DataGridComponent{
  public formGroup: FormGroup;
  protected editedRowIndex: number;

  public abstract addHandler({ sender });

  public abstract editHandler({ sender, rowIndex, dataItem });

  public cancelHandler({ sender, rowIndex }) {
    this.closeEditor(sender, rowIndex);
  }

  public abstract saveHandler({ sender, rowIndex, formGroup, isNew });

  public abstract removeHandler({ dataItem });

  protected closeEditor(grid, rowIndex = this.editedRowIndex) {
    grid.closeRow(rowIndex);
    this.editedRowIndex = undefined;
    this.formGroup = undefined;
  }
}
